import { ReactElement, ReactNode } from 'react';
import { IPlacingOrderButton } from '@components/PlacingOrderButtons/types';
import { TextColor } from '@components/Text';

export enum EPlacingOrderListItemCol {
  AVATAR,
  DEFAULT,
  LINK,
  WARNING,
  TRACKING_NUMBER,
}

export type TPlacingOrderPointCol = {
  color?: TextColor | undefined;
  icon?: string | undefined;
  title?: string;
  tooltip?: string | undefined;
  value: string | string[] | number;
}

export interface IPlacingOrderPointProps {
  actionEdit?: () => void;
  cols?: TPlacingOrderPointCol[];
  rows?: (string | undefined)[];
  title?: string | undefined;
}

export interface IPlacingOrderNoticeProps {
  description?: string;
  title: string | undefined;
}

export interface IPlacingOrderTabProps {
  handlerOnClick?: () => void;
  quantity?: number;
  selected?: boolean;
  title: string;
}

export type TPlacingOrderViewData = {
  description?: string | string[] | React.ReactNode | React.ReactNode[] | undefined;
  notice?: IPlacingOrderNoticeProps | undefined;
  points: IPlacingOrderPointProps[] | undefined;
  tabs?: IPlacingOrderTabProps[] | undefined;
  title: string;
};

export type TPlacingOrderListItemCol = {
  actionHover?: ReactNode | ReactElement | string | undefined;
  infoOnly?: boolean;
  title: string;
  tooltip?: string | undefined;
  type: EPlacingOrderListItemCol;
  value: string;
  withIcon?: boolean;
}

export type TPlacingOrderListItem = {
  cols: TPlacingOrderListItemCol[];
  countryCode?: string;
  id: string;
};

export interface IPlacingOrderViewProps {
  buttons?: IPlacingOrderButton[];
  currentStep?: number;
  numberOfSteps?: number | undefined;
  parcelsAny?: TPlacingOrderListItem[] | undefined;
  parcelsGood: TPlacingOrderListItem[] | undefined;
  placingOrderViewData: TPlacingOrderViewData;
}

export interface TPlacingOrderListProps {
  parcels: TPlacingOrderListItem[];
}

export interface IPlacingOrderListItemProps {
  cols: TPlacingOrderListItemCol[];
}
